module.exports = __webpack_public_path__ + "media/images/undraw_mobile-d7c68c1569537bdf1c11db2916c28d05.svg";